import React, { useState, useEffect } from 'react';
import CommonCheckbox from '../../../components/CommonCheckBox/CommonCheckbox';

const CallType = ({
  masterFilter,
  updateFilters,
  doReset,
  updateSelectionFieldsInHTMLFormatForDeSelect,
  singleSelection = true
}) => {
  const [callType, setCallType] = useState(masterFilter?.callType || {});
  const handleClick = data => {
    if (singleSelection) {
      return setCallType({
        [data?.key]: {
          ...data,
          status: !callType?.[data?.key]?.status
        }
      });
    }

    setCallType({
      ...callType,
      [data?.key]: {
        ...data,
        status: !callType?.[data?.key]?.status
      }
    });
  };

  useEffect(() => {
    updateFilters({
      key: 'callType',
      filters: callType
    });
    let onlyStatusTrue = {};
    Object.keys(callType || {})?.forEach(each => {
      if (callType[each]?.status) onlyStatusTrue[each] = callType[each];
    });

    updateSelectionFieldsInHTMLFormatForDeSelect({
      key: 'callType',
      object: onlyStatusTrue,
      handleCancel: handleCancel,
      displayName: 'name'
    });
  }, [callType]);

  const handleCancel = e => {
    setCallType(e);
  };

  useEffect(() => {
    if (doReset) {
      setCallType({});
    }
  }, [doReset]);

  let dataList = [
    {
      name: 'Completed',
      key: 'completed'
    },
    {
      name: 'Failed',
      key: 'failed'
    },
    {
      name: 'Busy',
      key: 'busy'
    },
    {
      name: 'No-Answer',
      key: 'no-answer'
    }
  ];

  return (
    <div className="w-full">
      <p className="font-roboto font-medium text-base">Call Type Filter</p>
      <div className="w-full mt-4  flex flex-wrap md:block md:grid md:grid-cols-3 md:gap-6">
        {dataList?.map(each => (
          <div className="flex mx-1 mt-1 md:mx-0 md:mt:0">
            <CommonCheckbox
              checked={callType[each?.key]?.status ? true : false}
              onChange={() => handleClick(each)}
            />
            <p className="text-grey-2234 font-roboto text-sm -ml-2">
              {each?.name}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CallType;
